module.exports = __webpack_public_path__ + "img/spring_trip-20160416-19.9134f9e1.jpg";